import { render, staticRenderFns } from "./JitsiMeet.vue?vue&type=template&id=3e7c7428&"
import script from "./JitsiMeet.vue?vue&type=script&lang=js&"
export * from "./JitsiMeet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports